// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chat_wrapper__6P-q0 {
  display: flex;
  justify-content: center;
  height: 100%;
}

.Chat_wrapperInner__2V0Fg {
  width: 100%;
}

.Chat_mainContainer__\\+GgTO {
  border: none;
}

.Chat_sources__UTahL {
  background-color: #F5F7F9;
  margin-left: 8px;
  margin-top: 8px;
  list-style-type: none;
  padding: 0;
}

.Chat_singleSource__MbWQv {
  margin-top: 2px;
}

.Chat_messageContentTest__FQo9y div {
  background-color: #F5F7F9 !important;
  border-radius: 8px;
}

.Chat_messageContentTest__FQo9y {
  border-radius: 8px;
}

.Chat_headerDetails__WppGC {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.Chat_headerDetailsAvatar__35CWl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
  margin-bottom: 8px;
}

.Chat_headerDetailsAvatar1__SmgvO {
  background-color: #FBD5E2;
}

.Chat_headerDetailsAvatar2__W\\+rCH {
  background-color: #C6F1DA;
}

.Chat_messageInput__dsSJp {
  border: 1px solid #CFD6DD !important;
  padding: 8px !important;
  border-radius: 8px !important;
  margin-left: 24px;
}

.Chat_messageInput__dsSJp > div {
  background-color: #FFFFFF !important;
}

.Chat_messageInput__dsSJp > div > div {
  background-color: #FFFFFF !important;
}

.Chat_messageInput__dsSJp div div div {
  background-color: #FFFFFF !important;
}

.Chat_thumb__UM8g3 {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.Chat_thumbUp__apB7r {
}

.Chat_thumbDown__UnSF8 {
  margin-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/Chat.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,yBCGM;EDFN,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAQA;EACI,oCAAA;EACA,kBAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;;AAQA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AALJ;;AASA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AANJ;;AASA;EAEI,yBCxCQ;ADkCZ;;AASA;EAEI,yBC5CO;ADsCX;;AASA;EACI,oCAAA;EACA,uBAAA;EACA,6BAAA;EACA,iBAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,6BAAA;EACA,YAAA;EACA,eAAA;AANJ;;AASA;AALA;;AASA;EACI,iBAAA;AALJ","sourcesContent":["@use '../../styles/colors' as colors; \n\n.wrapper {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n}\n\n.wrapperInner {\n    width: 100%;\n}\n\n.mainContainer {\n    border: none;\n}\n\n.sources {\n    background-color: colors.$neutral;\n    margin-left: 8px;\n    margin-top: 8px;\n    list-style-type: none;\n    padding: 0;\n}\n\n.singleSource {\n    margin-top: 2px;\n}\n\n// .customContent div {\n//     background-color: colors.$emerald7 !important;\n// }\n\n.messageContentTest div {\n    background-color: colors.$neutral !important;\n    border-radius: 8px;\n}\n\n.messageContentTest {\n    border-radius: 8px;\n}\n\n.headerDetails {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n\n.headerDetailsAvatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    margin-right: 12px;\n    margin-bottom: 8px;\n}\n\n.headerDetailsAvatar1 {\n    composes: headerDetailsAvatar;\n    background-color: colors.$raspberry;\n}\n\n.headerDetailsAvatar2 {\n    composes: headerDetailsAvatar;\n    background-color: colors.$greenAPP;\n}\n\n.messageInput {\n    border: 1px solid colors.$action !important;\n    padding: 8px !important;\n    border-radius: 8px !important;\n    margin-left: 24px;\n}\n\n.messageInput > div {\n    background-color: colors.$white !important;\n}\n\n.messageInput > div > div {\n    background-color: colors.$white !important;\n}\n\n.messageInput div div div {\n    background-color: colors.$white !important;\n}\n\n.thumb {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.thumbUp {\n    composes: thumb;\n}\n\n.thumbDown {\n    margin-left: 16px;\n    composes: thumb;\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Chat_wrapper__6P-q0`,
	"wrapperInner": `Chat_wrapperInner__2V0Fg`,
	"mainContainer": `Chat_mainContainer__+GgTO`,
	"sources": `Chat_sources__UTahL`,
	"singleSource": `Chat_singleSource__MbWQv`,
	"messageContentTest": `Chat_messageContentTest__FQo9y`,
	"headerDetails": `Chat_headerDetails__WppGC`,
	"headerDetailsAvatar": `Chat_headerDetailsAvatar__35CWl`,
	"headerDetailsAvatar1": `Chat_headerDetailsAvatar1__SmgvO Chat_headerDetailsAvatar__35CWl`,
	"headerDetailsAvatar2": `Chat_headerDetailsAvatar2__W+rCH Chat_headerDetailsAvatar__35CWl`,
	"messageInput": `Chat_messageInput__dsSJp`,
	"thumb": `Chat_thumb__UM8g3`,
	"thumbUp": `Chat_thumbUp__apB7r Chat_thumb__UM8g3`,
	"thumbDown": `Chat_thumbDown__UnSF8 Chat_thumb__UM8g3`
};
export default ___CSS_LOADER_EXPORT___;
